package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.getPost
import com.cybersoftsolution.cybersoftsolutionweb.api.subscribe
import com.cybersoftsolution.cybersoftsolutionweb.api.unsubscribe
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.HomePageUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.rememberSubscriber
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay


suspend fun CoroutineScope.unSubscribeUseCase(
    state: HomePageUI,
    setState: (HomePageUI) -> Unit,
    setIsSubscribing: (Boolean) -> Unit,
    email: String,
){
    val scope = this

    setIsSubscribing(true)

    unsubscribe(
        email = email,
    ).also { response ->

        delay(500)
//        console.log(response)

        if (email.isNotEmpty() && email.contains("@")) {
            if (response!=null)  {
                if (response.data == true) {
                    rememberSubscriber(
                        isSubscribe = false,
                        email = email,
                    )
                }
                setState(
                    state.copy(
                        isSubscribe = false,
                        email = email,
                        toastMessage = ToastMessage(
                            message = response.message?:"Sucripcion suspendida correctamente, esperamos verte pronto",
                            style = MyToastStyle.Success
                        )
                    )
                ).also {
                    scope.showMyToast(toastBasicID)
                }

            } else {
                setState(
                    state.copy(
                        isSubscribe = false,
                        email = email,
                        toastMessage = ToastMessage(
                            message = response?.message?:"Error al desubscribirse, por favor intente mas tarde",
                            style = MyToastStyle.Danger
                        )
                    )
                ).also {
                    scope.showMyToast(toastBasicID)
                }
            }
        } else {
            setState(
                state.copy(
                    isSubscribe = false,
                    email = email,
                    toastMessage = ToastMessage(
                        message = response?.message?:"Por favor ingrese un email valido",
                        style = MyToastStyle.Danger
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }
        }


        setIsSubscribing(false)


    }
}